// @ts-nocheck
/*import {
  SET_ALL_ACTIVE_DIVISIONS,
  SET_DIVISIONS_BY_SEASON,
  SET_DIVISION,
  SET_DIVISIONS_BY_LEAGUE,
  UPDATE_DIVISION
} from '../constants/actions';*/
import ActionTypes from "../constants/actions";
// import Immutable from "immutable";
import { Map, Record, Set } from "immutable";
import { mergeArraytoSet, addToSet, updateSet, removeFromSet } from "../utils/redux";
import _ from "lodash";

const defaultState = new Map({});
export const Division = Record({
  _id: "",
  name: "",
  season: {},
  league: {},
  layout: "",
  startDate: "",
  strengthLevel: 1,
  endDate: "",
  priority: 0
});
export default (state = new Set(), action) => {
  switch (action.type) {
    case ActionTypes.SET_ALL_ACTIVE_DIVISIONS:
    case ActionTypes.SET_DIVISIONS_BY_LEAGUE:
    case ActionTypes.SET_DIVISIONS_BY_PREV_LEAGUE:
    case ActionTypes.SET_DIVISIONS_BY_SEASON:
      return mergeArraytoSet(action.divisions, state, Division);
      // _.map(action.divisions, division => {
      //   if (division && division._id) state = state.set(division._id, division);
      // });
      // return state;
      break;
    case ActionTypes.UPDATE_DIVISION:
      if (action.division._id) return updateSet(action.division, state, Division);
    case ActionTypes.ADD_DIVISION:
    case ActionTypes.SET_DIVISION:
      console.log("SET_DIVISION: action: ", action);
      // if (action.division._id) return state.set(action.division._id, action.division);
      if (action.division._id) return addToSet(action.division, state, Division);
      break;

    case ActionTypes.DELETE_DIVISION:
      // return state.remove(action.division._id);
      return removeFromSet(action.division, state, Division);
      break;
    default:
      return state;
  }
};
